import { SET_APPLICANT_LIST } from "../../reducers/ui/applicantList";

export const setApplicantList = (influencerUIDs = []) => ({
  type: SET_APPLICANT_LIST,
  influencerUIDs
});
